<template>
  <div class="app-container">

    <!-- Formulaire d'inscription -->
    <RegistrationForm />

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
import RegistrationForm from '@/views/inscription/RegistrationForm.vue'
import AppFooter from '@/views/authentification/AppFooter.vue'

export default {
  name: "Registration",
  components: {
    RegistrationForm,
    AppFooter
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background: #f8fafa;
  display: flex;
  flex-direction: column;
}
</style>